module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VGPHOENIX-523f7941188f81d9d24483bf92465b83.png";